/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AttributeDefinitionDTO } from './AttributeDefinitionDTO';
import {
    AttributeDefinitionDTOFromJSON,
    AttributeDefinitionDTOFromJSONTyped,
    AttributeDefinitionDTOToJSON,
} from './AttributeDefinitionDTO';

/**
 * 
 * @export
 * @interface AttributesTreeSearchResultDTO
 */
export interface AttributesTreeSearchResultDTO {
    /**
     * 
     * @type {Array<AttributeDefinitionDTO>}
     * @memberof AttributesTreeSearchResultDTO
     */
    entries: Array<AttributeDefinitionDTO>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AttributesTreeSearchResultDTO
     */
    subPaths?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof AttributesTreeSearchResultDTO
     */
    totalCount: number;
}

/**
 * Check if a given object implements the AttributesTreeSearchResultDTO interface.
 */
export function instanceOfAttributesTreeSearchResultDTO(value: object): value is AttributesTreeSearchResultDTO {
    if (!('entries' in value) || value['entries'] === undefined) return false;
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    return true;
}

export function AttributesTreeSearchResultDTOFromJSON(json: any): AttributesTreeSearchResultDTO {
    return AttributesTreeSearchResultDTOFromJSONTyped(json, false);
}

export function AttributesTreeSearchResultDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttributesTreeSearchResultDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'entries': ((json['entries'] as Array<any>).map(AttributeDefinitionDTOFromJSON)),
        'subPaths': json['subPaths'] == null ? undefined : json['subPaths'],
        'totalCount': json['totalCount'],
    };
}

export function AttributesTreeSearchResultDTOToJSON(value?: AttributesTreeSearchResultDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'entries': ((value['entries'] as Array<any>).map(AttributeDefinitionDTOToJSON)),
        'subPaths': value['subPaths'],
        'totalCount': value['totalCount'],
    };
}

